import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import Card from "react-bootstrap/Card";
import { dataDecrypt, dataEncrypt } from "../app/utils/encryption-helper";
import { ApisService } from "./../app/core/apis.service";
import { FormatIndianDate } from "../app/utils/formatIndianDate";
import vyaparLogo from "../../src/assets/images/vyapar_live_main_logo.png"
import { GiMoneyStack, GiReceiveMoney, GiTakeMyMoney } from "react-icons/gi";

export const Retail = () => {
  const routerParams = useParams();
  const navigate = useNavigate();
  const [invoiceData, setInvoiceData] = useState<any>([]);
  const [pendingInvoiceData, setPendingInvoiceData] = useState<any>([]);
  const [completedInvoiceData, setCompletedInvoiceData] = useState<any>([]);
  // const [isOtpEntered, setIsOtpEntered] = useState(false);
  // const userData = useSelector((state: any) => state);
  const [loading, setLoading] = useState(false);
  // const [otpReference, setOtpReference] = useState("");

  // /retail/info/:id
  function formatTimestamp(timestamp: number): string {
    const dateObj = new Date(timestamp);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    const hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    return `${year}-${month}-${day} ${formattedHours}:${minutes} ${ampm}`;
  }

  useEffect(() => {
    loadInvoice();
  }, []);

  // useEffect(() => {
  //   if (userData?.UserDataReducer?.otp) {
  //     setIsOtpEntered(true);
  //   }
  // }, [userData]);

  async function loadInvoice(): Promise<void> {
    setLoading(true);
    try {
      const reqPayload = routerParams.id as string;
      const decryptdata: any = JSON.parse(dataDecrypt(reqPayload));
      let payload = {
        buyerId: decryptdata.buyerId,
        sellerId: decryptdata.sellerId,
        filter: {
          DateFrom: null,
          DateTo: null,
        },
      };
      const EncryptData = dataEncrypt(JSON.stringify(payload));
      // const preparedReference = dataEncrypt(
      //   JSON.stringify({
      //     bu: decryptdata.sellerId,
      //     customer: decryptdata.buyerId,
      //   })
      // );
      // setOtpReference(preparedReference);
      const res = await ApisService.getRetailInvoice(
        "getInvoices",
        EncryptData
      );
      const data: any = res.data.data;
      setLoading(false);
      const transactionData = JSON.parse(dataDecrypt(data));
      const pendingInvoices = transactionData?.results?.filter(
        (ele: any) => ele.payment_status === "pending"
      );
      const completedInvoices = transactionData?.results?.filter(
        (ele: any) => ele.payment_status === "completed"
      );

      setPendingInvoiceData(pendingInvoices);
      setCompletedInvoiceData(completedInvoices);
      setInvoiceData(transactionData);
    } catch (error) {
      console.error("Error in transaction:", error);
      setLoading(false);
    }
  }
  return (
    <div style={{ fontFamily: "Sans-serif" }}>
      {/* {!isOtpEntered && <LoginOtp type="retail" reference={otpReference} />} */}
      {/* {isOtpEntered && ( */}
      {loading && <div className="text-center mt-3"><div className="spinner-border" role="status"></div></div>}
      {!loading && <>
        <div className="mx-2 mt-2"><nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item cursor-pointer primary-color fw-bold" onClick={() => navigate(`/retail/${routerParams.id}`)}>invoice</li>
            <li className="breadcrumb-item active" aria-current="page">invoice details</li>
          </ol>
        </nav></div>
        {invoiceData?.results && <h2 className="ms-2 fw-bold primary-color text-center mt-2">{invoiceData?.results[0]?.buyer.name} Invoice List</h2>}
        <div className="container-fluid">
          {invoiceData?.results && <div
            style={{ borderRadius: "3px" }}
          >
            <div className="row align-items">
              <div className="col-8 fs-14">
                {invoiceData?.results[0]?.seller?.name && <div>{invoiceData?.results[0]?.seller?.name}</div>}
                <div>
                  {invoiceData?.results[0]?.seller?.address?.plot_no && <span>{invoiceData?.results[0]?.seller?.address?.plot_no},</span>}
                  {invoiceData?.results[0]?.seller?.address?.buildinghousenumber && <span>{invoiceData?.results[0]?.seller?.address?.buildinghousenumber},</span>}
                  {invoiceData?.results[0]?.seller?.address?.buildingstreetname && <span>{invoiceData?.results[0]?.seller?.address?.buildingstreetname},</span>}
                </div>
                <div>{invoiceData?.results[0]?.seller?.address?.villagetowncity && <span>{invoiceData?.results[0]?.seller?.address?.villagetowncity},</span>}
                  {invoiceData?.results[0]?.seller?.address?.state && <span>{invoiceData?.results[0]?.seller?.address?.state},</span>}
                  {invoiceData?.results[0]?.seller?.address?.postcode && <span>{invoiceData?.results[0]?.seller?.address?.postcode},{" "}</span>}
                </div>
                <div>{invoiceData?.results[0]?.seller?.mobile_number}.</div>
              </div>
              <div className="text-end col-4">
                <img src={vyaparLogo} alt="logo" className="vyapar-logo" />
              </div>
            </div>
          </div>}
          {/* <div className="row fs-14 mt-2">
              <div className="col-4 mb-2 text-center">
                <div className="fw-bold">Total Amount</div>
                <div>₹ {invoiceData.InvoiceTotalAmount}</div>
              </div>
              <div className="col-4 mb-2 text-center">
                <div className="fw-bold">Total Paid</div>
                <div>₹ {invoiceData.invoicePaidAmount}</div>
              </div>
              <div className="col-4 mb-2 text-center">
                <div className="fw-bold">Total Due</div>
                <div>₹ {invoiceData.invoicePendingAmount}</div>
              </div>
            </div> */}
          <div className="row mt-2">
            <div className="col-md-4 mb-2">
              <div className="card text-white skyblue-bg-border skyblue-bg-clr">
                <div className="card-body py-1">
                  <div className="d-flex justify-content-between align-items">
                    <div className="lh-0-5">
                      <div className="fs-4">₹ {invoiceData.InvoiceTotalAmount?.toFixed(2)}</div>
                      <div className="fs-6">Total Invoice Amount</div>
                    </div>
                    <div><GiTakeMyMoney size={35} /></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-2">
              <div className="card text-white dark-blue-border dark-blue-bg">
                <div className="card-body py-1">
                  <div className="d-flex justify-content-between align-items">
                    <div className="lh-0-5">
                      <div className="fs-4">₹ {invoiceData.invoicePendingAmount?.toFixed(2)}</div>
                      <div className="fs-6">Total Pending Amount</div>
                    </div>
                    <div><GiMoneyStack size={35} /></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card text-white bg-dark-orange dark-orange-border">
                <div className="card-body py-1">
                  <div className="d-flex justify-content-between align-items">
                    <div className="lh-0-5">
                      <div className="fs-4">₹ {invoiceData.invoicePaidAmount?.toFixed(2)}</div>
                      <div className="fs-6">Total Paid Amount</div>
                    </div>
                    <div><GiReceiveMoney size={35} /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="invoice-bg-clr rounded bg-white invoice-list px-2 pb-2">
            {pendingInvoiceData.length > 0 && <h5 className="text-secondary fw-bold ">Over Due</h5>}
            <div className="row">
              {pendingInvoiceData &&
                pendingInvoiceData.map((value: any, index: any) => (
                  <div className="col-12 col-md-6 col-lg-6 mb-2" key={index}>
                    <Card className="mb-2 shadow-sm border-1 rounded-3">
                      <Card.Body style={{ lineHeight: "0.6" }}>
                        <div className="d-flex justify-content-between align-items mb-2">
                          <div className="fs-6 primary-color">
                            <div className="fs-14">Due : <b>₹ {value?.pending_amount}</b></div>
                            <div className="mt-2 fs-14 text-secondary">Paid : ₹ {value?.paid_amount}</div>
                          </div>
                          <div>
                            <button className="rounded-pill px-4  fs-15 skyblue-bg-clr" style={{ padding: '13px' }} onClick={() => navigate(`/retail/info/${value?._id}`)}>
                              Invoice: # {value?.invoice_number?.toString().padStart(3, "0") || "001"}
                            </button>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between align-items">
                          <div className="dark-orange fs-14">{FormatIndianDate(value.created_date, "datewithrelative")}</div>
                          <h5 className="mb-0 text-center fw-bold me-4 primary-color">₹ {value.invoice_details.invoice_amount}</h5>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
            </div>
            {completedInvoiceData.length > 0 && <h5 className="mb-1 mt-3 text-secondary fw-bold">Completed</h5>}
            <div className="row">
              {completedInvoiceData &&
                completedInvoiceData.map((value: any, index: any) => (
                  <div className="col-12 col-md-6 col-lg-6 mb-2" key={index}>
                    <Card className="mb-2 shadow-sm border-1 rounded-3">
                      <Card.Body style={{ lineHeight: "0.6" }}>
                        <div className="d-flex justify-content-between align-items">
                          <div className="mt-2 fs-14">Paid : ₹  {value?.paid_amount}</div>
                          <div>
                            <button className="rounded-pill px-4 mb-2 fs-15 dark-blue-bg" style={{ padding: '13px' }} onClick={() => navigate(`/retail/info/${value?._id}`)}>
                              Invoice: # {value?.invoice_number?.toString().padStart(3, "0") || "001"}
                            </button>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between align-items">
                          <div className="skyblue-clr fs-14">{FormatIndianDate(value.created_date, "datewithrelative")}</div>
                          <h5 className="mb-0 text-center fw-bold me-4 primary-color">₹ {value.invoice_details.invoice_amount}</h5>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </>}
      {/* )} */}
    </div>

  );
};
